module.exports = __webpack_public_path__ + "img/vote.fbc17efb.png";